const getItemStyles = status => {
  switch (status) {
    case 'completed':
      return {
        backgroundColor: 'turquoise500'
      };
    case 'current':
      return {
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: 'turquoise500'
      };
    case 'upcoming':
    default:
      return {
        backgroundColor: 'slate100'
      };
  }
};

export { getItemStyles };
